import { UPDATE_USER, CLEAR_USER, CHECK_USER_REQUEST } from './loginReducer';

export const updateUser = (user, apiToken) => ({ type: UPDATE_USER, user, apiToken });
export const clearUser = () => ({ type: CLEAR_USER });

export const checkUser = () => ({ type: CHECK_USER_REQUEST });
